import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { EventTypeNode, IEventTypeNode } from "../eventType/eventTypeNode";
import { EventEditItem, IEventEditItem } from "./eventEditItem";
import { IdColorTitle, IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { EventSettingSimple, IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";

export interface IEventEdit {
    canHandleEvent: boolean;
    canRemoveEvent: boolean;
    canSaveEvent: boolean;
    canEditIdentificationData: boolean;
    item: IEventEditItem;
    createCompany: ICompanyMenuItem;
    companies: ICompanyMenuItem[];
    units: IIdTitleNode[];
    urgencyClasses: IIdColorTitle[];
    eventTypeNodes: IEventTypeNode[];
    eventTypeBNodes: IEventTypeNode[];
    eventTypeCNodes: IEventTypeNode[];
    eventSetting: IEventSettingSimple;
    maxEventMessageAttachmentSize: number;
}

export class EventEdit implements IEventEdit {
    canHandleEvent: boolean;
    canRemoveEvent: boolean;
    canSaveEvent: boolean;
    canEditIdentificationData: boolean;
    item: EventEditItem;
    createCompany: ICompanyMenuItem;
    companies: ICompanyMenuItem[];
    units: IdTitleNode[];
    urgencyClasses: IdColorTitle[];
    eventTypeNodes: EventTypeNode[];
    eventTypeBNodes: EventTypeNode[];
    eventTypeCNodes: EventTypeNode[];
    eventSetting: EventSettingSimple;
    maxEventMessageAttachmentSize: number;

    constructor();
    constructor(obj: IEventEdit);
    constructor(obj?: any) {
        this.canHandleEvent = obj && obj.canHandleEvent || false;
        this.canRemoveEvent = obj && obj.canRemoveEvent || false;
        this.canSaveEvent = obj && obj.canSaveEvent || false;
        this.canEditIdentificationData = obj && obj.canEditIdentificationData || false;
        this.item = new EventEditItem(obj ? obj.item : null);
        this.createCompany = new CompanyMenuItem(obj ? obj.createCompany : null);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.urgencyClasses = Base.getTypedArray(obj ? obj.urgencyClasses : null, IdColorTitle);
        this.eventTypeNodes = Base.getTypedArray(obj ? obj.eventTypeNodes : null, EventTypeNode);
        this.eventTypeBNodes = Base.getTypedArray(obj ? obj.eventTypeBNodes : null, EventTypeNode);
        this.eventTypeCNodes = Base.getTypedArray(obj ? obj.eventTypeCNodes : null, EventTypeNode);
        this.eventSetting = new EventSettingSimple(obj?.eventSetting);
        this.maxEventMessageAttachmentSize = obj && obj.maxEventMessageAttachmentSize || 0;
    }
}